/**
 * @generated SignedSource<<2eae4b692bf2d85e0c4a4a1862e4a480>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type historyEventsTableFragment$data = ReadonlyArray<{
  readonly createdAt: string;
  readonly createdBy: string;
  readonly jsonPayload: string | null;
  readonly " $fragmentType": "historyEventsTableFragment";
}>;
export type historyEventsTableFragment$key = ReadonlyArray<{
  readonly " $data"?: historyEventsTableFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"historyEventsTableFragment">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "historyEventsTableFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jsonPayload",
      "storageKey": null
    }
  ],
  "type": "CareProviderHistoryEntry",
  "abstractKey": null
};

(node as any).hash = "a2a49510d844cdc8b6133bfc0be37479";

export default node;
